// extracted by mini-css-extract-plugin
export default {"wrap":"login_wrap__+7upD","idwrap":"login_idwrap__PooUr","duplibtn":"login_duplibtn__GLlUL","white_box":"login_white_box__nR5Z2","fs_14":"login_fs_14__m8oGt"};